export default "__VITE_ASSET__DZjaX6WS__"